// =============================================================================
// BASE COMPONENT SERVICE
// =============================================================================
// Abstract service providing common functionality for components

import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Locale } from '../components/language-switcher/language.interface';
import { TranslationService } from './translation.service';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  public translationService = inject(TranslationService)
  public env: Environment = environment.name as Environment;
  public isSideNavOpen: WritableSignal<boolean> = signal(false)

  public toggleSidenav(state?: boolean) {
    this.isSideNavOpen.update(v => state!== undefined ? state : !v)
  }

  public switchLang(lang:Locale) {
    this.translationService.setLanguage(lang)
  }
}
export type Environment = 'local' | 'dev' | 'production';

